import { SelectBox } from "components/Select/Select";
import { Textbox } from "components/Textbox/Textbox";
import { useEffect, useState } from "react";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

interface ItemStockListProps {
  mode?: "edit" | "create" | "view";
  defaultValue: any;
  data: any;
  sendDataCallBack?: any;
  initialStock?:number
  useCalculateItemStock?:boolean
}
export const ItemStockList = ({
  mode,
  defaultValue,
  data,
  sendDataCallBack,
  initialStock=0,
  useCalculateItemStock=false
}) => {
const [newData,setNewData]=useState<any>()

useEffect(()=>{
  if(useCalculateItemStock){
let  newItemStock=[] as any
const exitedItem=data?.ItemStockList?.find((item)=>item?.ExpireDate==defaultValue?.ExpireDate && item?.PartyNo==defaultValue?.PartyNo)
console.log({exitedItem});

  if(exitedItem){

    
newItemStock=data?.ItemStockList?.map((item)=>{
  if(item?.ExpireDate==defaultValue?.ExpireDate && item?.PartyNo==defaultValue?.PartyNo && (((data?.HasExpireDate || data?.HasProductTracking) && (defaultValue?.ExpireDate && defaultValue?.PartyNo ) ) ||  (!data?.HasExpireDate && !data?.HasProductTracking))){
    return {...item,Stock:item?.Stock + initialStock}
  }
  else{
    return item
  }
})
  }
  else{
    
    if(((data?.HasExpireDate || data?.HasProductTracking) && (defaultValue?.ExpireDate && defaultValue?.PartyNo ) ) ||  (!data?.HasExpireDate && !data?.HasProductTracking))
    {

      data?.ItemStockList?.push({
        ExpireDate:defaultValue?.ExpireDate,
        PartyNo:defaultValue?.PartyNo,
        Stock:initialStock
      })
    }
newItemStock=data?.ItemStockList
  }
  

setNewData({...data,ItemStockList:newItemStock})
  }
  else{
setNewData(data)

  }

},[data])

  const [firstValue, setFirstValue] = useState<any>({
    ExpireDate: null,
    PartyNo: null,
  });

  const [selectedTotalValuseObj, setSelectedTotalValuseObj] = useState<any>({
    ExpireDate: defaultValue?.ExpireDate?defaultValue?.ExpireDate:null,
    PartyNo: defaultValue?.PartyNo?defaultValue?.PartyNo:null,
  });


  useEffect(() => {
    sendDataCallBack &&
      sendDataCallBack({
        ...selectedTotalValuseObj,
        Stock: newData?.ItemStockList?.find(
          (item) =>
            item.PartyNo == selectedTotalValuseObj?.PartyNo &&
            item.ExpireDate == selectedTotalValuseObj?.ExpireDate
        )?.Stock,
      });
  }, [selectedTotalValuseObj]);


  
  return (
    <div className="row ">
   {(defaultValue?.ExpireDate || (newData?.ItemStockList.length>1 && !defaultValue?.ExpireDate) || (newData?.ItemStockList?.[0]?.ExpireDate && !defaultValue?.ExpireDate) )&&   <div className="col-lg-4">
        <SelectBox
          onChange={(e) => {
            !firstValue.PartyNo &&
              setFirstValue({ ...firstValue, ExpireDate: e.target.value });
            setSelectedTotalValuseObj((prev) => {
              return {
                ...prev,
                PartyNo:!e.target.value?"":newData?.ItemStockList.find(item=>item?.ExpireDate==e.target.value &&prev?.PartyNo==item?.PartyNo)?prev?.PartyNo:newData?.ItemStockList.find(item=>item.ExpireDate==e.target.value)?.PartyNo,
                ExpireDate: e.target.value==""?null:e.target.value,
              };
            });
          }}
          valueString={mode=='view'?new DateObject(defaultValue?.ExpireDate).convert(persian, persian_fa).format():null}
          Change={(e) =>
            setSelectedTotalValuseObj((prev) => {
              return {
                ...prev,
                ExpireDate: e,
              };
            })
          }         
          mode={mode}
          lable="ExpireDate"
          selectType="select"
          value={defaultValue?.ExpireDate??null}
          options={newData?.ItemStockList?.filter((item) =>
            !firstValue?.PartyNo ? item : item?.PartyNo == firstValue?.PartyNo
          ).map((item) =>item?.ExpireDate? new DateObject(item?.ExpireDate).convert(persian, persian_fa).format():null)}
          val={newData?.ItemStockList?.filter((item) =>
            !firstValue?.PartyNo ? item : item?.PartyNo == firstValue?.PartyNo
          ).map((item) => item?.ExpireDate)}
          name={"ExpireDate"}
        ></SelectBox>
      </div>}

    { (defaultValue?.PartyNo   || (newData?.ItemStockList.length>1 && !defaultValue?.PartyNo)|| (newData?.ItemStockList?.[0]?.PartyNo && !defaultValue?.PartyNo)) && <div className="col-lg-4">
        <SelectBox
          onChange={(e) => {
            !firstValue?.ExpireDate &&
              setFirstValue({ ...firstValue, PartyNo: e.target.value });
            setSelectedTotalValuseObj((prev) => {
              return {
                ...prev,
                  ExpireDate:!e.target.value?null:newData?.ItemStockList.find(item=>item?.PartyNo==e.target.value &&prev?.ExpireDate==item?.ExpireDate)?prev?.ExpireDate:newData?.ItemStockList.find(item=>item?.PartyNo==e.target.value)?.ExpireDate,
                PartyNo: e.target.value,
              };
            });
          }}
          Change={(e) =>
            setSelectedTotalValuseObj((prev) => {
              return { ...prev, PartyNo: e };
            })
          }
valueString={mode=='view'?defaultValue?.PartyNo:null}
          mode={mode}
          lable="PartyNo"
          selectType="select"
          value={defaultValue?.PartyNo??null}
          options={newData?.ItemStockList?.filter((item) =>
            !firstValue?.ExpireDate
              ? item
              : item.ExpireDate == firstValue?.ExpireDate
          ).map((item) => item.PartyNo)}
          val={newData?.ItemStockList?.filter((item) =>
            !firstValue?.ExpireDate
              ? item
              : item.ExpireDate == firstValue?.ExpireDate
          ).map((item) => item.PartyNo)}
          name={"PartyNo"}
        ></SelectBox>
      </div>}
      {mode !== "view" && (
        <div className="col-lg-4">
          <Textbox
            textboxName="Stock"
            textboxType="number"
            labelText="Stock"
            value={
              
              newData?.ItemStockList?.find(
                (item) =>
                  item.PartyNo == selectedTotalValuseObj?.PartyNo &&
                  item.ExpireDate == selectedTotalValuseObj?.ExpireDate
              )?.Stock
            }
            defaultValue={
              newData?.ItemStockList?.find(
                (item) =>
                  item.PartyNo == selectedTotalValuseObj?.PartyNo &&
                  item.ExpireDate == selectedTotalValuseObj?.ExpireDate
              )?.Stock
            }
            mode={"view"}
          />
        </div>
      )}
    </div>
  );
};
